export const apiUrl = "https://back-api.dextopia.io/api"
export const apiUrl2 = 'https://back-api.dextopia.io/'
export const scanitUrl = "https://project-scanit-backend.bytesto.co/"
